 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth":"auth","admin":"admin","china":"china","editor":"editor","testimonials":"testimonials"}[chunkId]||chunkId) + "-legacy." + {"auth":"fc7c1b7b","chunk-009a1f26":"35e05946","chunk-29ba614d":"6c141a53","chunk-a69eec2a":"0dfa61b0","chunk-026ee61a":"f10cb70f","chunk-2960f116":"aaa14758","chunk-1867f6b0":"b9fcdb58","chunk-3191c8ff":"f81263b1","chunk-2b6fe9ac":"07b8e6a3","chunk-53bbc717":"779deb47","chunk-a3b1bf36":"9dc6b989","chunk-ddd608bc":"9361d65b","chunk-1ecb70de":"3c409fc7","chunk-33e724e4":"240c3fb1","chunk-115b0d40":"e6970e6d","chunk-97450cb8":"5bc654fb","chunk-e8a0ce2e":"8bf85701","admin":"0291cb63","chunk-1f128144":"bdfbc7e9","chunk-f616078e":"f63307d8","chunk-7569f4ee":"66f3ee87","chunk-aafd69c6":"e1abdf4c","chunk-d51d7488":"94fd701f","chunk-2d212edb":"d8246761","chunk-3d45f291":"9384ce53","chunk-0579aa71":"66379a77","chunk-19ffc2a4":"107ce953","chunk-22cfd354":"a4762431","chunk-10ab9e48":"04f915c7","chunk-22bed5ea":"ffe53b04","chunk-bfe6d5f2":"429b39fd","chunk-13387177":"ec9e44fa","chunk-16ca5586":"4550d76f","chunk-18980a18":"a1fb081a","chunk-21cf3418":"e91d9516","chunk-2d0d6b32":"f3a9e732","chunk-2d20ef97":"33880e9e","chunk-2d2223b5":"88a82d38","chunk-42b24e51":"8aeb1897","chunk-456290b2":"77e4cedf","chunk-4651d0c3":"20e23db1","chunk-4698ed09":"4d2e017b","chunk-52956a0e":"e7bfb400","chunk-614e17a0":"0c11dcd1","chunk-63e540d1":"7d04cb6a","chunk-6bf00080":"f04d9958","chunk-72ca96e8":"b1ad5b6a","chunk-730da07b":"1d117d23","chunk-73977901":"56806c48","chunk-74bd74af":"1a91ab06","chunk-7bbceb46":"cb43d689","chunk-1efa3873":"27920758","chunk-2d21a3d2":"592ab181","chunk-4828712e":"c324c374","chunk-894d1bb0":"e02b33c6","chunk-845429e4":"e2148cfe","chunk-96046a08":"249c2c7d","chunk-962cc990":"52cb0f14","chunk-abd82e2e":"0fc4425d","chunk-c1d4d0ce":"b42cc9c1","chunk-ca560910":"1833d5c3","chunk-d0e1218e":"47ea456b","chunk-97076eaa":"1db5e654","chunk-9bcbb67e":"caad084d","china":"533e554d","editor":"bc381f44","chunk-3c64c52e":"94c3efbe","testimonials":"81d8a638","chunk-2cf1c3bc":"ff895da8","chunk-2bb6fc98":"4b1964db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth":1,"chunk-009a1f26":1,"chunk-29ba614d":1,"chunk-a69eec2a":1,"chunk-1867f6b0":1,"chunk-3191c8ff":1,"chunk-2b6fe9ac":1,"chunk-53bbc717":1,"chunk-a3b1bf36":1,"chunk-ddd608bc":1,"chunk-1ecb70de":1,"chunk-33e724e4":1,"chunk-115b0d40":1,"chunk-97450cb8":1,"chunk-e8a0ce2e":1,"admin":1,"chunk-1f128144":1,"chunk-f616078e":1,"chunk-7569f4ee":1,"chunk-aafd69c6":1,"chunk-d51d7488":1,"chunk-3d45f291":1,"chunk-0579aa71":1,"chunk-19ffc2a4":1,"chunk-22cfd354":1,"chunk-10ab9e48":1,"chunk-22bed5ea":1,"chunk-bfe6d5f2":1,"chunk-13387177":1,"chunk-16ca5586":1,"chunk-18980a18":1,"chunk-21cf3418":1,"chunk-42b24e51":1,"chunk-456290b2":1,"chunk-4651d0c3":1,"chunk-4698ed09":1,"chunk-52956a0e":1,"chunk-614e17a0":1,"chunk-63e540d1":1,"chunk-6bf00080":1,"chunk-72ca96e8":1,"chunk-730da07b":1,"chunk-73977901":1,"chunk-7bbceb46":1,"chunk-1efa3873":1,"chunk-4828712e":1,"chunk-894d1bb0":1,"chunk-845429e4":1,"chunk-96046a08":1,"chunk-962cc990":1,"chunk-abd82e2e":1,"chunk-c1d4d0ce":1,"chunk-ca560910":1,"chunk-d0e1218e":1,"china":1,"editor":1,"chunk-3c64c52e":1,"testimonials":1,"chunk-2cf1c3bc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth":"auth","admin":"admin","china":"china","editor":"editor","testimonials":"testimonials"}[chunkId]||chunkId) + "." + {"auth":"0fc10067","chunk-009a1f26":"bb6df3f5","chunk-29ba614d":"9ad38ee9","chunk-a69eec2a":"a4562565","chunk-026ee61a":"31d6cfe0","chunk-2960f116":"31d6cfe0","chunk-1867f6b0":"ef35fc39","chunk-3191c8ff":"9d2e31a5","chunk-2b6fe9ac":"d0b708b9","chunk-53bbc717":"04cd3ac3","chunk-a3b1bf36":"1b226cac","chunk-ddd608bc":"a523d8a3","chunk-1ecb70de":"b8f8c4b1","chunk-33e724e4":"150005f6","chunk-115b0d40":"e9718bf9","chunk-97450cb8":"12361cfa","chunk-e8a0ce2e":"1cdd137a","admin":"4236543a","chunk-1f128144":"4cda0225","chunk-f616078e":"f78aa42a","chunk-7569f4ee":"d03e4e05","chunk-aafd69c6":"0b06fc0d","chunk-d51d7488":"d151dce1","chunk-2d212edb":"31d6cfe0","chunk-3d45f291":"b795aa91","chunk-0579aa71":"cafff5b5","chunk-19ffc2a4":"9edf92b6","chunk-22cfd354":"df1520f9","chunk-10ab9e48":"f0c1e20d","chunk-22bed5ea":"ca57c33f","chunk-bfe6d5f2":"51a51792","chunk-13387177":"1f12777a","chunk-16ca5586":"fe6f1897","chunk-18980a18":"fe6f1897","chunk-21cf3418":"79e4cdfe","chunk-2d0d6b32":"31d6cfe0","chunk-2d20ef97":"31d6cfe0","chunk-2d2223b5":"31d6cfe0","chunk-42b24e51":"a86c0184","chunk-456290b2":"022e48db","chunk-4651d0c3":"a2722a0f","chunk-4698ed09":"b7a6bc14","chunk-52956a0e":"f63c0c43","chunk-614e17a0":"ea7d610c","chunk-63e540d1":"d2bda9e5","chunk-6bf00080":"cd19d05c","chunk-72ca96e8":"84860559","chunk-730da07b":"cff496df","chunk-73977901":"461c058b","chunk-74bd74af":"31d6cfe0","chunk-7bbceb46":"54792e5e","chunk-1efa3873":"fe9a3a2f","chunk-2d21a3d2":"31d6cfe0","chunk-4828712e":"54570902","chunk-894d1bb0":"821b8471","chunk-845429e4":"a62fc479","chunk-96046a08":"c02a992e","chunk-962cc990":"8deb5807","chunk-abd82e2e":"a62fc479","chunk-c1d4d0ce":"a62fc479","chunk-ca560910":"a62fc479","chunk-d0e1218e":"59896504","chunk-97076eaa":"31d6cfe0","chunk-9bcbb67e":"31d6cfe0","china":"3997d0ca","editor":"9cd13ad5","chunk-3c64c52e":"82b477bd","testimonials":"8c07e4ca","chunk-2cf1c3bc":"8e963ab9","chunk-2bb6fc98":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
